module.exports = __webpack_public_path__ + "static/media/tip-2.8a02bda5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/tip-2.jpeg
// module id = 538
// module chunks = 0